export const getDecimalPrecision = (value) => {
  const normalized = String(value);

  if (normalized.includes('e-')) {
    const [, exp] = normalized.split('e-');
    return Number(exp) || 0;
  }

  const dotIndex = normalized.indexOf('.');
  return dotIndex >= 0 ? normalized.length - dotIndex - 1 : 0;
};

export const normalizeNumberByStep = (value, step = 1) => {
  const precision = getDecimalPrecision(step);
  return Number(Number(value).toFixed(precision));
};

export const hasMaxFractionDigits = (value, maxDigits = 2, epsilon = 1e-8) => {
  if (value == null || value === '') {
    return true;
  }

  const numeric = Number(value);
  if (Number.isNaN(numeric)) {
    return false;
  }

  const scale = 10 ** maxDigits;
  return Math.abs(numeric * scale - Math.round(numeric * scale)) < epsilon;
};
